const serviceReferral = (values) => {
  const emailReadyValues = {};
  Object.keys(values).forEach((key) => { emailReadyValues[key] = values[key] || ''; });

  return `Hello,
The following child/caregiver may be eligible and interested in receiving your services.
Please contact them for more information.

${emailReadyValues.additionalMessage}

Child Name: ${emailReadyValues.childName}
Date of Birth: ${emailReadyValues.birthDate}
Custody Status: ${emailReadyValues.csChildLegalStatusCustody}
SACWIS Person ID: ${emailReadyValues.personId}
SACWIS Case ID: ${emailReadyValues.caseId}
${emailReadyValues.county} Caseworker Name: ${emailReadyValues.wkrName}
Caseworker E-mail: ${emailReadyValues.wkrEmail}

Caregiver name: ${emailReadyValues.providerName}
Caregiver Address: ${emailReadyValues.providerAddress}
Caregiver Phone Number: ${emailReadyValues.providerContact}
Placement Type: ${emailReadyValues.placementType}

Placement Agency: ${emailReadyValues.providerAgency}
Placement Agency Phone Number: ${emailReadyValues.providerAgencyContact}

Thank you`;
};

export default serviceReferral;
